import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { Suspense, lazy } from 'react';
import type { ReactNode } from 'react';
import { Ladeanzeige } from '../components/Ladeanzeige';
import { istEntwicklungsLogin, leseEntwicklungsBenutzer } from './entwicklungsLogin';
import { anmeldeAnfrageFuerApi } from './msalConfig';
import { msalInstanz } from './msalInstanz';

// Nur lokal gebraucht: eigener Chunk, damit er nicht im Haupt-Bundle liegt.
const EntwicklungsLoginSeite = lazy(() =>
  import('../pages/EntwicklungsLoginSeite').then((m) => ({ default: m.EntwicklungsLoginSeite })),
);

/**
 * Kein anonymer Bereich: Ohne Anmeldung wird nichts darunter angezeigt (N-02).
 * Produktion: MSAL erzwingt den Redirect-Login. Lokal: Entwicklungs-Login mit Benutzerauswahl.
 */
export function Anmeldung({ children }: { children: ReactNode }) {
  if (istEntwicklungsLogin) {
    return leseEntwicklungsBenutzer() ? (
      children
    ) : (
      <Suspense fallback={<Ladeanzeige />}>
        <EntwicklungsLoginSeite />
      </Suspense>
    );
  }
  return (
    <MsalProvider instance={msalInstanz()}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={anmeldeAnfrageFuerApi()}
        loadingComponent={() => <Ladeanzeige text="Anmeldung läuft …" />}
      >
        {children}
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}
